// src/authConfig.js
export const msalConfig = {
    auth: {
        clientId: "55524e37-8475-4214-b844-0c904f5eea21",
        authority: "https://login.microsoftonline.com/6b18a503-6d51-463a-a8f6-c6e822f85be7",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["User.Read", "email", "openid", "profile", "offline_access"],
};
